import { AISaasLogoIcon } from "@uiview/views/AISaas/AISaasPreview/icons";
import styles from "./Header.module.scss";

export function Logo() {
  return (
    <div className={styles.aISaasLogo}>
      <AISaasLogoIcon />
    </div>
  );
}
